<template>
  <div class="broadcast-commerce">
    <div class="tickets">
      <card-minimal title="Manually added tickets" class="no-bg">
        <ticket-list type="video" :selector="`video:${this.video.id}`" empty-list="No manually added tickets" />
      </card-minimal>
      <card-minimal title="Automatically added tickets" class="no-bg m-t-4">
        <ticket-list type="video" selector="video:*" :removeable="false" empty-list="No automatically added tickets" />
      </card-minimal>
    </div>
    <card-minimal title="Ticket options" class="options no-bg">
      <Button class="f-w" @click="addTicket = true">Add ticket</Button>
      <Button class="f-w m-t-3" @click="freeTicket = true">Send free ticket</Button>
    </card-minimal>

    <portal to="modals">
      <modal :show="addTicket" @close="addTicket = false" title="Add ticket to video">
        <ticket-add type="video" />
      </modal>
      <free-ticket type="video" :show="freeTicket" @close="freeTicket = false" />
    </portal>
  </div>
</template>

<script>

import TicketList from '@/components/Products/TicketList.vue';
import TicketAdd from '@/components/Products/TicketAdd.vue';
import FreeTicket from '@/components/Products/FreeTicket.vue';

export default {
  components: {
    TicketAdd,
    TicketList,
    FreeTicket,
  },
  computed: {
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    video() {
      return this.$store.getters['Video/current'];
    },
  },
  data() {
    return {
      addTicket: false,
      freeTicket: false,
    };
  },
  mounted() {
    this.$store.dispatch('Products/getAllStreams');
  },
};
</script>

<style lang="scss" scoped>
.broadcast-commerce {
  display: flex;
  flex-direction: column;
  width: 100%;

  .tickets {
    flex: 2;
    order: 1;
    margin-top: 25px;
  }

  .options {
    flex: 1;
    order: 0;
  }

  @media (min-width: 768px) {
    flex-direction: row;

    .tickets {
      margin-top: 0;
      order: 0;
    }

    .options {
      margin-top: 0;
      margin-left: 25px;
      max-width: 450px;
      order: 1;
    }
  }
}
</style>
